import React, { memo } from "react";
import { motion } from "framer-motion";
import {
  gameOverContainerVariants,
  gameOverItemVariants,
} from "../animations/variants";
import { GAME_CONFIG } from "../config/gameConfig";
import type { Player } from "../types";
import winEgg from "../assets/images/win-egg.png";

interface WinScreenProps {
  opponent: Player;
  me: Player;
  wins: Record<string, number>;
}

function WinScreenComponent({}: WinScreenProps): React.ReactElement {
  return (
    <div className="absolute inset-0 overflow-hidden" style={{ zIndex: 50 }}>
      {/* ── TITLE + WATERMARK ── */}
      <div
        className="absolute inset-0 flex flex-col items-center overflow-hidden pointer-events-none select-none"
        style={{ zIndex: 0 }}
      >
        {/* Title */}
        <span className="there-brat-font !font-[400] text-[36px] text-[#1A8BF7] mb-2">
          CONGRATULATIONS
        </span>

        {/* Watermark ispod titlea */}
        <div className="flex flex-col items-center opacity-80">
          {Array.from(
            { length: GAME_CONFIG.animation.watermarkRepeatCount },
            (_, i) => (
              <span
                key={i}
                className="italic uppercase whitespace-nowrap text-[50px] leading-[1.05] tracking-[-0.03em] gilroy-font !font-[1000]"
                style={
                  i === 0
                    ? { color: "white" }
                    : {
                        WebkitTextStroke:
                          "1px rgba(255,255,255," + (1 - i * 0.05) + ")",
                        WebkitTextFillColor: "transparent",
                        color: "transparent",
                        opacity: 1 - i * 0.28,
                      }
                }
              >
                WINNING BATTLE
              </span>
            ),
          )}
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <motion.div
        variants={gameOverContainerVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="relative z-10 flex flex-col items-center justify-center h-full pb-12 gap-4"
        style={{ willChange: "opacity" }}
      >
        {/* Egg */}
        <motion.div
          variants={gameOverItemVariants}
          className="relative flex items-center justify-center mt-[120px]"
          style={{ willChange: "transform, opacity", width: 400, height: 220 }}
        >
          <img
            src={winEgg}
            alt="egg"
            className="relative z-10"
            style={{
              width: "100%",
              height: "auto",
              filter:
                "drop-shadow(0 8px 28px rgba(0,0,0,0.85)) drop-shadow(0 0 12px rgba(255,215,0,0.3))",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}

export const WinScreen = memo(WinScreenComponent);
